import { Icon, type IconTone } from './Icon';

/**
 * Посмотреть чужими глазами: карточка персонажа в открытом реестре.
 *
 * Фигура из набора lucide (ISC). Не `OpenIcon` (рамка со стрелкой наружу):
 * тот про «уйти на другой экран», а здесь важно не перемещение, а то, ЧТО
 * игрок увидит — свою карточку такой, какой её видят читатели.
 */
export function EyeIcon({ size, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={24} strokeWidth={2} tone={tone}>
      <path d="M2.06 12.35a1 1 0 0 1 0-.7 10.75 10.75 0 0 1 19.88 0 1 1 0 0 1 0 .7 10.75 10.75 0 0 1-19.88 0" />
      <circle cx="12" cy="12" r="3" />
    </Icon>
  );
}
